import { useList } from '../../../../../../api';
import { ShiftRoasterApiParams } from '../types';

export function useMyShiftRoster({
  params,
}: {
  params?: ShiftRoasterApiParams;
}) {
  const { data, isLoading, refetch, isFetching, isRefetching } = useList(
    'shift-management/employees/my-shift-rosters',
    {
      ...params,
    },
  );

  return {
    data: data?.data?.data,
    count: data?.data?.total,
    isLoading: isLoading || isFetching || isRefetching,
    refetch,
  };
}
